const styles = () => ({
  root: {
    textAlign: 'right',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
  },
  multiline: {
    marginTop: 6,
    marginBottom: 6,
  },
  dense: {},
  inset: {
    paddingLeft: 56,
  },
  primary: {},
  secondary: {},
});

export default styles;
